export default blockTabs => {
    // console.log('singleGolfMainContent');
    const tabsList = document.querySelector('.tabs-list');
    const menuItemsBtn = document.querySelectorAll('.menu-item-btn');
    const blockTabsContentContainer = document.querySelector('.block-tabs-content-container');
    const blockTabsContents = blockTabsContentContainer.querySelectorAll('.block-tabs-content');

    function menuUpdate(tab) {
        for (const menuItemBtn of menuItemsBtn) {
            const dataContent = menuItemBtn.getAttribute('data-content');

            menuItemBtn.parentNode.classList.remove('current-menu-item');

            if (dataContent === tab) {
                menuItemBtn.parentNode.classList.add('current-menu-item');
            }
        }
    }

    function toggleContent(tab) {
        for (const blockTabsContent of blockTabsContents) {
            blockTabsContent.classList.remove('active');

            if (blockTabsContent.id === tab) {
                blockTabsContent.classList.add('active');
            }
        }
    }

    for (const menuItemBtn of menuItemsBtn) {
        menuItemBtn.addEventListener('click', event => {
            const dataContentId = event.target.getAttribute('data-content');

            toggleContent(dataContentId);
            menuUpdate(dataContentId);
        });
    }
};
